import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  root: {
    padding: "0 !important",
    marginTop: "8px",
  },
  cardContent: {
    padding: 0,
    margin: 0,
  },
  tableStyle: {
    borderCollapse: "separate",
    borderSpacing: "0 12px",
    width: "100%",
  },
  // -- Row ---------------------------------------------------------------
  row: {
    backgroundColor: "transparent",
    transition: "background-color 0.2s ease",
  },
  rowCell: {
    padding: 0,
    border: "none",
  },
  rowContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 26px",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(12px)",
    borderRadius: "18px",
    border: "1px solid rgba(0, 0, 0, 0.045)",
    transition:
      "border-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      borderColor: "rgba(225, 48, 108, 0.15)",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.04)",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "4px",
      background: "linear-gradient(to bottom, #833AB4, #E1306C, #FCAF45)",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },
    "&:hover::before": {
      opacity: 1,
    },
    [theme.breakpoints.down(500)]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "14px",
    },
  },
  // -- Page Info ---------------------------------------------------------
  pageInfo: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  pageAvatar: {
    height: "44px",
    width: "44px",
    borderRadius: "12px",
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,0.06)",
    flexShrink: 0,
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },
  pageName: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "15px",
    color: "#1a1a1a",
    lineHeight: "1.3",
  },
  sourceTag: {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#888",
    marginTop: "2px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    textTransform: "capitalize",
  },
  // -- Action Buttons ----------------------------------------------------
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
    [theme.breakpoints.down(500)]: {
      width: "100%",
      justifyContent: "flex-end",
    },
  },
  actionBtn: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13px",
    padding: "8px 20px",
    borderRadius: "10px",
    textTransform: "none",
    minWidth: "110px",
    transition: "all 0.2s ease",
    boxShadow: "none",
    "&:active": {
      transform: "scale(0.96)",
    },
  },
  btnConnect: {
    color: "#cc2366",
    backgroundColor: "rgba(204, 35, 102, 0.05)",
    border: "1px solid rgba(204, 35, 102, 0.15)",
    "&:hover": {
      backgroundColor: "rgba(204, 35, 102, 0.1)",
      borderColor: "rgba(204, 35, 102, 0.3)",
    },
  },
  btnDisconnect: {
    color: "#E34D59",
    backgroundColor: "rgba(227, 77, 89, 0.05)",
    border: "1px solid rgba(227, 77, 89, 0.15)",
    "&:hover": {
      backgroundColor: "rgba(227, 77, 89, 0.12)",
      borderColor: "rgba(227, 77, 89, 0.35)",
    },
  },
  removeBtn: {
    color: "#bbb",
    padding: "10px",
    transition: "all 0.2s ease",
    "&:hover": {
      color: "#E34D59",
      backgroundColor: "rgba(227, 77, 89, 0.08)",
      transform: "rotate(10deg)",
    },
  },
  // -- Modal -------------------------------------------------------------
  modalIcon: {
    fontSize: "28px",
  },
}));

export default useStyle;
